import { type QueryHookOptions, type TypedDocumentNode, gql, useQuery } from '@apollo/client';

type NationalKidsStatsResponse = {
  kidsFoundationStats: {
    _id: string;
    numberOfKidsEngaged: number;
    programsCompleted: number;
    numberOfVolunteersMobilized: number;
    citiesActivated: number;
  };
};

const NATIONAL_KIDS_STATS_QUERY: TypedDocumentNode<NationalKidsStatsResponse> = gql`
  query NationalKidsStatsQuery {
    kidsFoundationStats {
      _id
      numberOfKidsEngaged
      programsCompleted
      numberOfVolunteersMobilized
      citiesActivated
    }
  }
`;

const useKidsFoundationStats = (opts?: QueryHookOptions<NationalKidsStatsResponse>) => {
  return useQuery(NATIONAL_KIDS_STATS_QUERY, opts);
};

export default useKidsFoundationStats;
